import React from 'react';

const AI = () => {
    return (
        <div className="skills__content">
            <h3 className="skills__title">Artificial Intelligence</h3>

            <div className="skills__box">
                <div className="skills__group">
                    
                    <div className="skills__data">
                        <i class='bx bx-badge-check' ></i>

                        <div>
                            <h3 className="skills__name">Python</h3>
                            <span className='skills__level'>Intermediate</span>
                        </div>
                    </div>

                    
                    <div className="skills__data">
                        <i class='bx bx-badge-check' ></i>

                        <div>
                            <h3 className="skills__name">OpenCV</h3>
                            <span className='skills__level'>Intermediate</span>
                        </div>
                    </div>

                    
                    <div className="skills__data">
                        <i class='bx bx-badge-check' ></i>

                        <div>
                            <h3 className="skills__name">NLP</h3>
                            <span className='skills__level'>Basic</span>
                        </div>
                    </div>
                </div>

                <div className="skills__group">
                    
                    <div className="skills__data">
                        <i class='bx bx-badge-check' ></i>

                        <div>
                            <h3 className="skills__name">Game</h3>
                            <span className='skills__level'>Basic</span>
                        </div>
                    </div>

                    
                    <div className="skills__data">
                        <i class='bx bx-badge-check' ></i>

                        <div>
                            <h3 className="skills__name">Blender</h3>
                            <span className='skills__level'>Basic</span>
                        </div>
                    </div>

                    
                    <div className="skills__data">
                        <i class='bx bx-badge-check' ></i>

                        <div>
                            <h3 className="skills__name">ThreeJS</h3>
                            <span className='skills__level'>Basic</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AI